import { getPlatform } from '@app/mappers/reguest-settings.mapper';
import { isDevelopmentEnvironmentByAmplitude } from '@amplitude/mappers/is-development-amplitude.mapper';
import { UserAddresses } from '@app/modules/core/interfaces/address';
import { TrackingState } from '@app/store/reducers/tracking.reducer';
import { UserInfo } from '@app/modules/core/interfaces/user';
import { EventProperties, ProductProperties, SearchProperties } from '@avo/interface/trigger-props';
import { TriggerEvent } from '@avo/interface/trigger-entity';

export function getEventProps(
  isMobile: boolean,
  utms: TrackingState,
  eventParams: EventProperties,
): EventProperties {
  const params = eventParams ?? {};
  const BASE_PROPS = {
    ...params,
    ...utms,
  }
  const TESTING_PROPS = isDevelopmentEnvironmentByAmplitude() ? { IS_TESTING: true } : {};
  return {
    ...BASE_PROPS,
    ...TESTING_PROPS,
    TRAVEL_PLATFORM: getPlatform(isMobile)
  };
}

export function getTriggerEvent(
  eventName: string,
  eventProps: EventProperties,
  searchProps: SearchProperties,
  productProps: ProductProperties,
  userAddresses: UserAddresses,
  user: UserInfo,
): TriggerEvent {
  return {
    EVENT_NAME: eventName,
    EVENT_PROPS: eventProps,
    SEARCH_PROPS: searchProps ?? null,
    PRODUCT_PROPS: productProps ?? null,
    USER: user,
    USER_ADDRESSES: userAddresses
  };
}
